import { useEffect, useState, useRef } from 'react';
import { supabase } from '../../../config/supabase';

interface CompanyLogo {
  id: number;
  company_name: string;
  logo_url: string;
  display_order: number;
}

export default function CompaniesBanner() {
  const [logos, setLogos] = useState<CompanyLogo[]>([]);
  const [loading, setLoading] = useState(true);
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    fetchLogos();
  }, []);

  const fetchLogos = async () => {
    try {
      const { data, error } = await supabase
        .from('company_logos')
        .select('*')
        .eq('is_active', true)
        .order('display_order', { ascending: true });

      if (error) throw error;
      
      if (data && data.length > 0) {
        setLogos(data);
      }
    } catch (error) {
      console.error('Error fetching company logos:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading || logos.length === 0) {
    return null;
  }

  // Double the logos for seamless infinite scroll
  const duplicatedLogos = [...logos, ...logos];
  
  // Faster speed: 1.5 seconds per logo (was 3 seconds)
  const animationDuration = logos.length * 1.5;

  return (
    <section className="w-full py-8 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-6">
          <div className="text-navy text-sm sm:text-base font-serif tracking-wider">EQUITY INVESTMENTS</div>
        </div>
        <div className="bg-white rounded-2xl shadow-xl p-8 overflow-hidden">
          <div className="relative overflow-hidden">
            <div 
              ref={scrollRef}
              className="flex"
              style={{
                animation: `scroll-seamless-logos ${animationDuration}s linear infinite`,
                width: 'fit-content'
              }}
            >
              {duplicatedLogos.map((logo, index) => (
                <div
                  key={`${logo.id}-${index}`}
                  className="flex-shrink-0 mx-8 grayscale hover:grayscale-0 transition-all duration-300"
                  style={{ width: '150px', height: '80px' }}
                >
                  <img
                    src={logo.logo_url}
                    alt={logo.company_name}
                    className="w-full h-full object-contain"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
